<ng-container *ngIf="filteredPatients.length; else noItems">
    <mat-list>
        <ng-container *ngFor="let group of filteredPatients">
            <div class="list-header">{{group.date | date: 'longDate'}}</div>
            <mat-list-item *ngFor="let patient of group.patients" (click)="navigateToPatientFile(patient.id)"
                class="auto-height" [appPatientValidationStatus]="patient" #valStatus="appPatientValidationStatus"
                [appPatientActive]="patient.id">
                <div class="patient-item stack-mobile">
                    <div class="patient-details">
                        <app-patient-validation-messages [valStatus]="valStatus"> </app-patient-validation-messages>
                        <div matLine class="patient-name">
                            <b>{{ patient.surname }}, {{ patient.name }}</b>
                            <span class="patient-number" *ngIf="patient.patientNumber">({{
                                patient.patientNumber }})</span>
                        </div>
                        <div matLine class="patient-diagnosis">
                            <span>{{ patient.medicalAid }}
                                <ng-container *ngIf="patient.medicalAidNumber"> -
                                    {{patient.medicalAidNumber}}</ng-container>
                                <ng-container *ngIf="patient.medicalAidPlan"> (Plan: {{patient.medicalAidPlan}}
                                    <ng-container *ngIf="patient.medicalDependantCode">, Dep: {{
                                        patient.medicalDependantCode}}</ng-container>)</ng-container>

                            </span>
                        </div>
                        <div matLine class="patient-diagnosis" *ngIf="patient.gapCover">
                            <span>Gap Cover: {{ patient.gapCover }}
                                <ng-container *ngIf="patient.gapCoverNumber"> -
                                    {{patient.gapCoverNumber}}</ng-container>
                            </span>
                        </div>
                        <div matLine class="patient-diagnosis">
                            <span>{{ patient.diagnosis }}</span>
                        </div>
                        <div matLine *ngIf="patient.diagnosis2" class="patient-secondary-diagnosis">
                            <span>{{ buildDiagnosisString(patient) }}</span>
                        </div>
                        <div matLine class="patient-secondary-diagnosis">
                            <div class="code-list">
                                <span *ngFor="let codeObj of patient.codes; let last = last"
                                      class="code-item"
                                      [class.code-removed]="codeObj.state?.removed"
                                      [matTooltip]="providerTooltip.computedTooltip"
                                      #providerTooltip="appProviderInitialsTooltip"
                                      [appProviderInitialsTooltip]="codeObj"
                                      [existingTooltip]="getCodeTooltip(codeObj)"
                                      [showFinancialTooltip]="!stateUnit"
                                      [matTooltipClass]="'financial-tooltip'">
                                    {{ codeObj.code }}{{ !stateUnit && codeObj.paidCash ? ' (Paid Up Front)' : '' }}{{ !stateUnit && codeObj.noCharge ? ' (Pro Bono)' : '' }}<span class="code-chip code-chip--connect" *ngIf="codeObj.state?.connectAdded">Connect</span><span class="code-chip" [ngClass]="chip.cls" *ngFor="let chip of codeObj.state?.chips || []">{{ chip.label }}</span>{{ !last ? ', ' : '' }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="action-icons">
                        <button mat-icon-button *ngIf="patient.isGroupPaid"
                            (click)="togglePaidCash($event, group.date, patient.originalCodes, true)"
                            matTooltip="Mark all coding for this patient and date as paid up front">
                            <mat-icon>credit_card</mat-icon>
                        </button>
                        <button mat-icon-button color="primary" *ngIf="!patient.isGroupPaid"
                            (click)="togglePaidCash($event, group.date, patient.originalCodes, false)"
                            matTooltip="Mark all coding for this patient and date as NOT paid up front">
                            <mat-icon>credit_card</mat-icon>
                        </button>
                        <button mat-icon-button *ngIf="patient.isGroupNoCharge"
                            (click)="toggleNoCharge($event, group.date, patient.originalCodes, true)"
                            matTooltip="Mark all coding for this patient and date as pro bono">
                            <mat-icon>money_off</mat-icon>
                        </button>
                        <button mat-icon-button color="primary" *ngIf="!patient.isGroupNoCharge"
                            (click)="toggleNoCharge($event, group.date, patient.originalCodes, false)"
                            matTooltip="Mark all coding for this patient and date as NOT pro bono">
                            <mat-icon>attach_money</mat-icon>
                        </button>
                        <button mat-icon-button
                            (click)="loadCodeGroup($event, group.date, patient.id, patient.originalCodes)"
                            matTooltip="Edit the codes for this patient and date">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button (click)="navigateToPatientFile(patient.id, $event)"
                            matTooltip="Load the patient file">
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </div>

                </div>
            </mat-list-item>
        </ng-container>
    </mat-list>
    <div class="mobile-spacer"></div>
</ng-container>

<ng-template #noItems>
    <p class="no-records-message">No coding records found.</p>
</ng-template>